/* ============================================================
   NIGHTLEGS — PRODUCT GALLERY
   Thumbnail switching, keyboard navigation, swipe on mobile
   ============================================================ */

(function() {
  'use strict';

  var gallery  = document.getElementById('product-gallery');
  var viewport = document.getElementById('gallery-viewport');
  var prevBtn  = document.getElementById('gallery-prev');
  var nextBtn  = document.getElementById('gallery-next');
  var track    = document.getElementById('gallery-track');

  if (gallery && viewport && track) {
    var realSlides = Array.prototype.slice.call(track.querySelectorAll('.product-gallery__slide'));
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.gallery-thumb'));
    var thumbsWrap = document.getElementById('gallery-thumbs');
    var n = realSlides.length;
    var loop = n > 1;          // only loop when there is more than one image
    var pos = loop ? 1 : 0;    // DOM index shown (1 = first real slide once clones exist)
    var animating = false;
    function vw() { return viewport.clientWidth; }

    // SEAMLESS infinite loop: clone the last slide before the first and the first
    // after the last. Moving past either end lands on a clone (visually identical to
    // the real slide), then we snap to the real twin with no animation — so it reads
    // as "wraps around forever," not a jarring rewind to the start.
    if (loop) {
      var headClone = realSlides[n - 1].cloneNode(true);
      var tailClone = realSlides[0].cloneNode(true);
      headClone.classList.add('is-clone'); headClone.setAttribute('aria-hidden', 'true');
      tailClone.classList.add('is-clone'); tailClone.setAttribute('aria-hidden', 'true');
      track.insertBefore(headClone, realSlides[0]);
      track.appendChild(tailClone);
    }

    function realIndex() {              // DOM position -> real slide index
      if (!loop) return pos;
      if (pos === 0) return n - 1;      // head clone shows the last slide
      if (pos === n + 1) return 0;      // tail clone shows the first slide
      return pos - 1;
    }

    function setActive() {
      var ri = realIndex();
      thumbs.forEach(function(t, idx) { t.classList.toggle('is-active', idx === ri); });
      // Scroll the thumbnail STRIP (not the page) so the active preview tracks along
      // and stays centered instead of disappearing off the edge as you advance.
      var t = thumbs[ri];
      if (thumbsWrap && t) {
        var target = t.offsetLeft - (thumbsWrap.clientWidth - t.offsetWidth) / 2;
        thumbsWrap.scrollTo({ left: target < 0 ? 0 : target, behavior: 'smooth' });
      }
    }

    function apply(animate) {
      track.style.transition = animate ? 'transform .3s ease' : 'none';
      track.style.transform = 'translate3d(' + (-pos * vw()) + 'px,0,0)';
    }

    // Animate to a DOM position, then settle: if we landed on a clone, jump to its
    // real twin instantly. A timeout (not transitionend) drives the settle so it
    // always fires and never deadlocks, even on rapid clicks.
    function move(toPos) {
      if (animating) return;
      pos = toPos;
      animating = true;
      apply(true);
      setActive();
      setTimeout(function () {
        if (loop) {
          if (pos === n + 1) { pos = 1; apply(false); }
          else if (pos === 0) { pos = n; apply(false); }
        }
        animating = false;
      }, 340);
    }

    function next() { if (!loop) { if (pos < n - 1) move(pos + 1); return; } move(pos + 1); }
    function prev() { if (!loop) { if (pos > 0) move(pos - 1); return; } move(pos - 1); }
    function goReal(i) { move(loop ? i + 1 : i); }

    apply(false); setActive();

    thumbs.forEach(function(thumb, i) { thumb.addEventListener('click', function() { goReal(i); }); });
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);
    document.addEventListener('keydown', function(e) {
      if (document.activeElement && document.activeElement.closest('#cart-drawer')) return;
      if (e.key === 'ArrowLeft')  prev();
      if (e.key === 'ArrowRight') next();
    });

    window.addEventListener('resize', function() { apply(false); });

    // ---- Finger-swipe with vertical/horizontal intent detection ----
    // CSS sets `touch-action: pan-y`, so a vertical gesture scrolls the PAGE; we take
    // over only once a gesture is clearly horizontal.
    var startX = 0, startY = 0, baseX = 0, dragging = false, axis = null;
    viewport.addEventListener('touchstart', function(e) {
      if (n < 2 || animating) return;
      var t = e.touches[0];
      startX = t.clientX; startY = t.clientY;
      baseX = -pos * vw();
      dragging = true; axis = null;
      track.style.transition = 'none';
    }, { passive: true });

    viewport.addEventListener('touchmove', function(e) {
      if (!dragging) return;
      var t = e.touches[0];
      var dx = t.clientX - startX, dy = t.clientY - startY;
      if (axis === null) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;     // wait for a clear direction
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (axis === 'y') { dragging = false; return; }          // vertical -> page scrolls
      if (e.cancelable) e.preventDefault();                    // horizontal -> we own it
      track.style.transform = 'translate3d(' + (baseX + dx) + 'px,0,0)';
    }, { passive: false });

    function endDrag(e) {
      if (!dragging) { axis = null; return; }
      var wasX = axis === 'x';
      dragging = false; axis = null;
      if (!wasX) return;
      var t = (e.changedTouches && e.changedTouches[0]) || null;
      var dx = t ? t.clientX - startX : 0;
      var threshold = vw() * 0.15;
      if (dx <= -threshold) next();
      else if (dx >= threshold) prev();
      else move(pos); // not far enough — snap back to the current slide
    }
    viewport.addEventListener('touchend', endDrag, { passive: true });
    viewport.addEventListener('touchcancel', endDrag, { passive: true });

    // Variant change → jump to that variant's image
    document.addEventListener('variant:changed', function(e) {
      if (!e.detail || !e.detail.variant) return;
      var varImage = e.detail.variant.featured_image;
      if (!varImage || !varImage.src) return;
      var key = varImage.src.split('?')[0].split('/').pop();
      realSlides.forEach(function(s, i) {
        var img = s.querySelector('img');
        if (img && img.src.indexOf(key) !== -1) goReal(i);
      });
    });
  }

  // (Product accordion toggle handled in theme.js via event delegation)

  // Quantity selector
  var qtyInput = document.getElementById('qty-input');
  var qtyMinus = document.getElementById('qty-minus');
  var qtyPlus  = document.getElementById('qty-plus');

  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function() {
      var v = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      qtyInput.value = v;
    });

    qtyPlus.addEventListener('click', function() {
      var v = Math.min(99, parseInt(qtyInput.value, 10) + 1);
      qtyInput.value = v;
    });

    qtyInput.addEventListener('change', function() {
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) qtyInput.value = 1;
      if (v > 99) qtyInput.value = 99;
    });
  }

  // Variant selection
  var variantInputs = document.querySelectorAll('.swatch__input');
  var variantIdInput = document.getElementById('selected-variant-id');
  var productData;

  try {
    var jsonEl = document.getElementById('product-json');
    if (jsonEl) productData = JSON.parse(jsonEl.textContent);
  } catch(e) {}

  // ---- Bundle selector (quantity-based) ----
  var selectedQty = 1;
  (function initBundles() {
    var bundlesEl = document.getElementById('bundles');
    if (!bundlesEl) return;
    var cards = Array.prototype.slice.call(bundlesEl.querySelectorAll('.bundle-card'));
    // Product JSON prices arrive already converted by Shopify Markets; the
    // total_override is authored in shop (USD) cents, so it must be converted here.
    var shopCurrency = (window.Shopify && window.Shopify.currency) || {};
    var fxRate = parseFloat(shopCurrency.rate) || 1;
    var curSymbol = { GBP: '£', EUR: '€' }[shopCurrency.active] || '$';
    function money(c) { return curSymbol + (Math.round(c) / 100).toFixed(2); }
    function unitPrice() {
      var id = variantIdInput ? parseInt(variantIdInput.value, 10) : null;
      if (productData && productData.variants) {
        var v = productData.variants.filter(function(x){ return x.id === id; })[0] || productData.variants[0];
        if (v) return v.price;
      }
      return 0;
    }
    // Per-unit anchor for the single-pair card: the variant's compare-at price when set above price.
    function compareUnit() {
      var id = variantIdInput ? parseInt(variantIdInput.value, 10) : null;
      if (productData && productData.variants) {
        var v = productData.variants.filter(function(x){ return x.id === id; })[0] || productData.variants[0];
        if (v && v.compare_at_price && v.compare_at_price > v.price) return v.compare_at_price;
      }
      return 0;
    }
    var unitNoun = (bundlesEl.dataset.noun || 'pair').toLowerCase();
    function cardTotal(card, u) {
      var q = parseInt(card.dataset.qty, 10) || 1;
      // Mirror the cart's charge exactly: local (Markets-rounded) unit price × qty
      // minus the automatic discount converted at the live FX rate.
      var discAmt = parseInt(card.dataset.discountAmount, 10);
      if (discAmt > 0) return Math.max(0, Math.round(u * q - discAmt * fxRate));
      var override = parseInt(card.dataset.total, 10);
      if (override > 0) return Math.round(override * fxRate);
      var d = parseFloat(card.dataset.discount) || 0;
      return Math.round(u * q * (1 - d / 100));
    }
    function render() {
      var u = unitPrice();
      cards.forEach(function(card) {
        var q = parseInt(card.dataset.qty, 10) || 1;
        // Anchor every card on the variant compare-at price (falls back to price when unset).
        var cu = compareUnit();
        var baseUnit = cu > u ? cu : u;
        var comp = baseUnit * q, tot = cardTotal(card, u), per = q ? Math.round(tot / q) : tot;
        var t = card.querySelector('[data-role="total"]');
        var c = card.querySelector('[data-role="compare"]');
        var s = card.querySelector('[data-role="save"]');
        if (t) t.textContent = money(tot);
        if (c) c.textContent = comp > tot ? money(comp) : '';
        if (s) {
          if (comp > tot) { s.textContent = 'SAVE ' + money(comp - tot) + ' · ' + money(per) + ' per ' + unitNoun; s.hidden = false; }
          else { s.textContent = ''; s.hidden = true; }
        }
      });
    }
    function updateAtcLabel() {
      var sel = bundlesEl.querySelector('.bundle-card.is-selected');
      var tot = sel ? cardTotal(sel, unitPrice()) : unitPrice();
      var q = selectedQty || 1;
      var nounLabel = q + ' ' + unitNoun.charAt(0).toUpperCase() + unitNoun.slice(1) + (q > 1 ? 's' : '');
      var atc = document.getElementById('product-atc-btn');
      if (atc && !atc.disabled) atc.textContent = 'Add ' + nounLabel + ' to Cart · ' + money(tot);
      var stickyPrice = document.querySelector('.sticky-atc__price');
      if (stickyPrice) stickyPrice.textContent = money(tot);
      var stickyNote = document.querySelector('.sticky-atc__note');
      if (stickyNote) stickyNote.textContent = nounLabel + ' · 90-night guarantee';
    }
    function selectCard(card) {
      cards.forEach(function(c) { c.classList.remove('is-selected'); var i = c.querySelector('input'); if (i) i.checked = false; });
      card.classList.add('is-selected');
      var inp = card.querySelector('input'); if (inp) inp.checked = true;
      selectedQty = parseInt(card.dataset.qty, 10) || 1;
      updateAtcLabel();
    }
    cards.forEach(function(card) { card.addEventListener('click', function() { selectCard(card); }); });
    // Presell hand-off (/pages/the-spot): ?pairs=N preselects the tier she picked there;
    // from=spot adds a one-line confirmation above the tiers (nlSpotRibbon).
    var nlParams = null;
    try { nlParams = new URLSearchParams(window.location.search); } catch (e) {}
    var wantQty = nlParams ? parseInt(nlParams.get('pairs'), 10) : NaN;
    var wanted = wantQty ? Array.prototype.filter.call(cards, function(c) { return (parseInt(c.dataset.qty, 10) || 1) === wantQty; })[0] : null;
    var init = wanted || bundlesEl.querySelector('.bundle-card.is-selected') || cards[0];
    if (init) selectCard(init);
    (function nlSpotRibbon() {
      if (!nlParams || nlParams.get('from') !== 'spot' || document.getElementById('nl-spot-ribbon')) return;
      var rib = document.createElement('p');
      rib.id = 'nl-spot-ribbon';
      rib.setAttribute('role', 'status');
      rib.style.cssText = 'display:flex;align-items:center;gap:8px;margin:0 0 12px;padding:10px 14px;' +
        'background:#FCFAF5;border:1.5px solid #E0913C;border-radius:8px;color:#1A2744;' +
        'font-weight:700;font-size:15px;line-height:1.4;';
      var icon = document.createElement('span');
      icon.className = 'material-symbols-rounded';
      icon.setAttribute('aria-hidden', 'true');
      icon.style.cssText = 'color:#2F6B49;font-size:20px;flex-shrink:0;';
      icon.textContent = 'check_circle';
      rib.appendChild(icon);
      rib.appendChild(document.createTextNode('Your pair is picked below. You have 90 nights to decide.'));
      var head = bundlesEl.parentNode && bundlesEl.parentNode.querySelector('.bundle-heading');
      var anchor = head || bundlesEl;
      anchor.parentNode.insertBefore(rib, anchor);
    })();
    render(); updateAtcLabel();
    document.addEventListener('variant:changed', function() { render(); updateAtcLabel(); });
  })();

  if (variantInputs.length && productData) {
    variantInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        // Update swatch UI
        var group = input.closest('.product-swatches');
        if (group) {
          group.querySelectorAll('.swatch').forEach(function(s) { s.classList.remove('is-selected'); });
          input.closest('.swatch').classList.add('is-selected');
        }

        // Update variant label
        var pos = parseInt(input.dataset.optionPosition, 10);
        var labelEl = document.getElementById('variant-label-' + pos);
        if (labelEl) labelEl.textContent = input.value;

        // Find matching variant
        var selected = {};
        document.querySelectorAll('.swatch__input:checked').forEach(function(i) {
          selected[parseInt(i.dataset.optionPosition, 10)] = i.value;
        });

        var matched = productData.variants.find(function(v) {
          return v.options.every(function(opt, idx) {
            return selected[idx + 1] === opt;
          });
        });

        if (matched) {
          if (variantIdInput) variantIdInput.value = matched.id;

          var atcBtn = document.getElementById('product-atc-btn');
          var stickyBtn = document.getElementById('sticky-atc-btn');

          if (atcBtn) {
            atcBtn.dataset.variantId = matched.id;
            atcBtn.textContent = 'Add to Cart — Risk-Free';
            atcBtn.disabled = false;
          }

          if (stickyBtn) {
            stickyBtn.dataset.variantId = matched.id;
            stickyBtn.disabled = false;
          }

          // Update price
          var priceBlock = document.getElementById('product-price-block');
          if (priceBlock && matched.price) {
            var price = (matched.price / 100).toFixed(2);
            var compareEl = priceBlock.querySelector('.price');
            if (compareEl) compareEl.textContent = '$' + price;
          }

          document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: matched } }));
        }
      });
    });
  }

  // Add to cart
  function nightlegsAdd(btn) {
    var variantId = btn.dataset.variantId || (variantIdInput && variantIdInput.value);
    if (!variantId) return;
    var qty = selectedQty || 1;
    if (window.NightLegsCart && typeof window.NightLegsCart.addItem === 'function') {
      window.NightLegsCart.addItem(variantId, qty, btn);
    } else {
      var root = (window.nightlegs && window.nightlegs.rootUrl) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
      }).then(function() { window.location.href = (window.nightlegs && window.nightlegs.cartUrl) || '/cart'; });
    }
  }

  var atcBtn = document.getElementById('product-atc-btn');
  if (atcBtn) atcBtn.addEventListener('click', function() { nightlegsAdd(atcBtn); });

  var stickyAtcBtn = document.getElementById('sticky-atc-btn');
  if (stickyAtcBtn) stickyAtcBtn.addEventListener('click', function() { nightlegsAdd(stickyAtcBtn); });
})();
